// extracted by mini-css-extract-plugin
export default {"more":"more__9bbe2012","content":"content__9bbe2012","image_wrapper":"image_wrapper__9bbe2012","desc":"desc__9bbe2012","detail":"detail__9bbe2012"};